// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2m-6";
export var headerCell = "_2m-2";
export var rowWrapper = "_2m-4";
export var stickyAggregationCell = "_2m-a";
export var stickyAggregationRow = "_2m-7";
export var stickyColumnCell = "_2m-9";
export var stickyColumnHeaderCell = "_2m-8";
export var table = "_2m-1";
export var virtualRowWrapper = "_2m-5";
export var virtualTableContainer = "_2m-0";
export var white = "_2m-3";